export default {"src":"/_next/static/media/dai.8480b930.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};